import React from 'react';
import {Link} from 'react-router-dom';
import AurButton from '../../../common/aur-button/AurButton';

const Button: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Button</h1>
        <div>
          Buttons allow users to take actions, and make choices, with a single
          tap.
        </div>

        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurButton
            type="text"
            title="Click me"
            label="Click me"
            size="Medium"
          />
        </div>
      </div>
    </>
  );
};

export default Button;
